<template>
  <!-- 额度 -->
  <div class="loan_card">
    <div class="loan_card-label">ДОСТУПНАЯ СУММА КРЕДИТА</div>
    <div class="loan_amount-row">
      <div>
        <div class="loan_step loan_step-active" @click="getreduce" v-if="loannum >= 5000 && loannum != minAmount">−</div>
        <div class="loan_step" @click="getreduce" v-else>−</div>
      </div>
      <div class="loan_amount">{{ unitConverter(loannum) }} ₸</div>
      <div class="loan_step loan_step-active" @click="getadd">+</div>
    </div>
    <div class="loan_total">
      <span class="ode">Сумма к погашению:</span>
      <span class="nkl">{{ unitConverter(displayRepayAmount) }} ₸</span>
    </div>
    <div class="loan_button" @click="gogoolplay">Получить деньги</div>
    <div class="loan_note">*В зависимости от срока и суммы микрокредита</div>
  </div>
</template>

<script>
  export default {
    name: 'LoanCard',
    props: {
      initialAmount: {
        type: Number,
        default: 165000,
      },
      minAmount: {
        type: Number,
        default: 10000,
      },
      maxAmount: {
        type: Number,
        default: 185000,
      },
      repayAmount: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        loannum: this.initialAmount,
        Interest: 0,
      };
    },
    computed: {
      displayRepayAmount() {
        return this.repayAmount || this.loannum
      }
    },
    methods: {
      getadd() {
        if (this.loannum == this.maxAmount) return
        this.loannum += 5000
        this.Interest = this.loannum * 1.0001
      },
      getreduce() {
        if (this.loannum >= 5000 && this.loannum != this.minAmount) {
          this.loannum -= 5000
          this.Interest = this.loannum * 1.0001
        }
      },
      unitConverter(e) {
        if (!e) return 0
        const intPart = Math.trunc(e)
        const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        let floatPart = ''
        const valueArray = e.toString().split('.')
        if (valueArray.length === 2) {
          floatPart = valueArray[1].toString()
          return intPartFormat + '.' + floatPart
        }
        return intPartFormat + floatPart
      },
      gogoolplay() {
        location.href = 'https://play.google.com/store/apps/details?id=kzcredit.mfo.loan.bank.kredit.cash.money.fast'
      }
    },
  }
</script>

<style scoped>
  .loan_card{
    width: 2.78rem;
    border-radius: 0.08rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0rem 0.02rem 0.05rem rgba(0, 0, 0, 0.06);
    padding: 0.13rem;
  }
  .loan_card-label{
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.06rem;
    margin-bottom: 0.08rem;
  }
  .loan_amount-row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.13rem;
  }
  .loan_step{
    width: 0.23rem;
    height: 0.23rem;
    border-radius: 50%;
    border: 0.01rem solid #bfdbfe;
    color: #60a5fa;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 0.07rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.8);
    cursor: pointer;
  }
  .loan_step-active{
    background: #2f76d2;
    color: #ffffff;
    border-color: #2f76d2;
  }
  .loan_amount{
    color: rgba(0, 102, 204, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.15rem;
  }
  .loan_total{
    background: #edf4fe;
    border-radius: 0.06rem;
    padding: 0.08rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.13rem;
  }
  .ode{
    color: rgba(102, 102, 102, 1);
    font-family: Montserrat;
    font-weight: 400;
    font-size: 0.07rem;
  }
  .nkl{
    color: rgba(51, 51, 51, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.07rem;
  }
  .loan_button{
    height: fit-content;
    padding: 0.13rem 0rem;
    border-radius: 0.06rem;
    background: rgba(0, 102, 204, 1);
    box-shadow: 0rem 0.01rem 0.04rem rgba(0, 0, 0, 0.16);
    color: rgba(255, 255, 255, 1);
    font-family: Montserrat;
    font-weight: 800;
    font-size: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.05rem;
    cursor: pointer;
  }
  .loan_note{
    color: rgba(153, 153, 153, 1);
    font-family: Montserrat;
    font-weight: 400;
    font-size: 0.06rem;
  }

  @media screen and (max-width: 768px) {
    .loan_card {
      width: 100%;
      box-sizing: border-box;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/loancard.vue